module.exports = __webpack_public_path__ + "static/media/onboardingpageImage.920993b5.png";